export const API_URL =
  process.env.VUE_APP_ROOT_API + process.env.VUE_APP_BASE_API

export const STRIPE_API = process.env.VUE_APP_STRIPE_API

export const STRIPE_API_US = process.env.VUE_APP_STRIPE_API_US

export const MAX_TIME_REMAINING = 7

export const IS_CPF = 11

export const IS_CNPJ = 14

export const BR_PANDA_AFFILIATES_LINK = 'https://afiliados.pandavideo.com.br/'
export const PANDA_AFFILIATES_LINK = 'https://affiliates.pandavideo.com/'

export const PANDA_HELP_LINK = 'https://help.pandavideo.com/pt-br/'
export const US_PANDA_HELP_LINK = 'https://help.pandavideo.com/en-us/'

export const PANDA_HELP_STORAGE_LINK =
  'https://help.pandavideo.com/pt-br/article/como-funciona-o-espaco-de-armazenamento-dos-videos-1gt1eft/'
export const US_PANDA_HELP_STORAGE_LINK =
  'https://help.pandavideo.com/en-us/article/how-does-the-video-storage-space-work-guk6az/'

export const PANDA_HELP_TRAFFIC_LINK =
  'https://help.pandavideo.com/pt-br/article/o-que-e-trafego-de-videos-ckj2on/'
export const US_PANDA_HELP_TRAFFIC_LINK =
  'https://help.pandavideo.com/en-us/article/what-is-video-traffic-and-how-does-it-work-742s06/'

export const PANDA_HELP_LIVE_LINK =
  'https://help.pandavideo.com/pt-br/article/como-fazer-live-na-panda-p99j5w/'
export const US_PANDA_HELP_LIVE_LINK =
  'https://help.pandavideo.com/en-us/article/how-to-live-on-panda-1jr682d/'

export const PANDA_HELP_FACEBOOKPIXEL_LINK =
  'https://help.pandavideo.com/pt-br/article/id-do-facebook-pixel-pj2pyc/'
export const US_PANDA_HELP_FACEBOOKPIXEL_LINK =
  'https://help.pandavideo.com/pt-br/article/id-do-facebook-pixel-pj2pyc/'

export const PANDA_HELP_SAVE_VIDEO_PROGRESS_LINK =
  'https://help.pandavideo.com/pt-br/article/como-salvar-o-progresso-do-video-no-navegador-99iowe/'
export const US_PANDA_HELP_SAVE_VIDEO_PROGRESS_LINK =
  'https://help.pandavideo.com/pt-br/article/como-salvar-o-progresso-do-video-no-navegador-99iowe/'

export const PANDA_HELP_RETENTION_METRICS_LINK =
  'https://help.pandavideo.com/pt-br/article/como-funciona-as-metricas-de-retencao-6fm147/'
export const US_PANDA_HELP_RETENTION_METRICS_LINK =
  'https://help.pandavideo.com/en-us/article/how-does-the-retention-graph-work-1b91n27/'

export const PANDA_PAUSE_THUMBNAIL =
  'https://help.pandavideo.com/pt-br/article/como-funciona-o-novo-recurso-de-thumbnail-de-pause-3gzxys/?bust=1673979934142'
export const US_PANDA_PAUSE_THUMBNAIL =
  'https://help.pandavideo.com/en-us/article/how-does-the-new-pause-thumbnail-feature-work-y31qtq/?bust=1673962405847'

export const PANDA_USER_MANAGEMENT =
  'https://help.pandavideo.com/pt-br/article/como-adicionar-usuarios-na-panda-video-dj1u3f/'
export const US_PANDA_USER_MANAGEMENT =
  'https://help.pandavideo.com/en-us/article/how-does-multi-user-functionality-work-mqv1ct/'

export const PANDA_CREDITS =
  'https://help.pandavideo.com/pt-br/article/como-funcionam-os-creditos-da-panda-video-sl8v0f/'
export const US_PANDA_CREDITS =
  'https://help.pandavideo.com/pt-br/article/como-funcionam-os-creditos-da-panda-video-sl8v0f/'

export const EBOOK_LINK =
  'https://help.pandavideo.com/pt-br/article/panda-ia-ebook-21wysx/?bust=1702927566161'
export const US_EBOOK_LINK =
  'https://help.pandavideo.com/pt-br/article/panda-ia-ebook-21wysx/?bust=1702927566161'

export const MENTALMAP_LINK =
  'https://help.pandavideo.com/pt-br/article/panda-ia-mapa-mental-1q9ca0i/?bust=1702927566159'
export const US_MENTALMAP_LINK =
  'https://help.pandavideo.com/pt-br/article/panda-ia-mapa-mental-1q9ca0i/?bust=1702927566159'

export const CREDITS_IN_DOUBLE =
  'https://help.pandavideo.com/pt-br/article/creditos-em-dobro-campanha-1kenzp0/'
export const ES_CREDITS_IN_DOUBLE =
  'https://help.pandavideo.com/es/article/creditos-dobles-campana-p4gg5n/'
export const US_CREDITS_IN_DOUBLE =
  'https://help.pandavideo.com/en-us/article/double-credits-campaign-qvnz74/'

export const CUSTOMIZE_PROGRESS_BAR =
  'https://help.pandavideo.com/pt-br/article/como-configurar-a-barra-de-progresso-ficticia-na-panda-video-eao2gk/'
export const ES_CUSTOMIZE_PROGRESS_BAR =
  'https://help.pandavideo.com/es/article/como-configurar-la-barra-de-progreso-ficticia-en-panda-video-15fn7ca/'
export const US_CUSTOMIZE_PROGRESS_BAR =
  'https://help.pandavideo.com/en-us/article/how-to-set-up-the-dummy-progress-bar-in-panda-video-gmigfu'

export const CUSTUMIZE_COLORS =
  'https://help.pandavideo.com/pt-br/article/personalizar-configuracoes-do-player-cores-controles-entre-outras-funcoes-1r4o24y/'
export const ES_CUSTUMIZE_COLORS =
  'https://help.pandavideo.com/es/article/personalizar-configuraciones-del-player-colores-controles-y-otras-funciones-o2xfbx/'
export const US_CUSTUMIZE_COLORS =
  'https://help.pandavideo.com/en-us/article/customize-player-settings-colors-controls-and-other-functions-1dvsqlw/'

export const CUSTUMIZE_CONTROLS =
  'https://help.pandavideo.com/pt-br/article/configuracoes-basicas-do-player-cores-controles-entre-outras-funcoes-69hcpz/'
export const ES_CUSTUMIZE_CONTROLS =
  'https://help.pandavideo.com/en-us/article/basic-player-settings-colors-controls-and-other-functions-duztwl/'
export const US_CUSTUMIZE_CONTROLS =
  'https://help.pandavideo.com/es/article/configuraciones-basicas-del-player-colores-controles-y-otras-funciones-15wxfm4/'

export const BIG_PLAY_BUTTON =
  'https://help.pandavideo.com/pt-br/article/configuracoes-basicas-do-player-cores-controles-entre-outras-funcoes-69hcpz/'
export const ES_BIG_PLAY_BUTTON =
  'https://help.pandavideo.com/es/article/configuraciones-basicas-del-player-colores-controles-y-otras-funciones-15wxfm4/'
export const US_BIG_PLAY_BUTTON =
  'https://help.pandavideo.com/en-us/article/basic-player-settings-colors-controls-and-other-functions-duztwl/'

export const AI_SUBTITLES_LINK =
  'https://help.pandavideo.com/pt-br/article/panda-ia-legendas-automaticas-18uac9t/?bust=1702927566160'
export const US_AI_SUBTITLES_LINK =
  'https://help.pandavideo.com/pt-br/article/panda-ia-legendas-automaticas-18uac9t/?bust=1702927566160'

export const QUIZ_LINK =
  'https://help.pandavideo.com/pt-br/article/panda-ia-quizperguntas-651o7k/?bust=1702927566161'
export const US_QUIZ_LINK =
  'https://help.pandavideo.com/pt-br/article/panda-ia-quizperguntas-651o7k/?bust=1702927566161'

export const AI_DUBBING_LINK =
  'https://help.pandavideo.com/pt-br/article/panda-ia-dublagem-automatica-1lmzxwn/?bust=1702927566162'
export const US_AI_DUBBING_LINK =
  'https://help.pandavideo.com/pt-br/article/panda-ia-dublagem-automatica-1lmzxwn/?bust=1702927566162'
export const AI_LINK =
  'https://help.pandavideo.com/pt-br/article/como-funciona-nossa-inteligencia-artificial-1gly8ci/?bust=1702927566163'
export const US_AI_LINK =
  'https://help.pandavideo.com/pt-br/article/como-funciona-nossa-inteligencia-artificial-1gly8ci/?bust=1702927566163'
export const SMART_SEARCH_LINK =
  'https://help.pandavideo.com/pt-br/article/panda-ia-busca-no-video-1m4rn5o/?bust=1703157181838'
export const US_SMART_SEARCH_LINK =
  'https://help.pandavideo.com/en-us/article/panda-ai-video-search-m6sp8x/'
export const ES_SMART_SEARCH_LINK =
  'https://help.pandavideo.com/es/article/panda-ia-busqueda-en-video-3qdsnk/'
export const DRM_LINK_PT_BR =
  'https://help.pandavideo.com/pt-br/article/o-que-e-e-como-funciona-o-nosso-drmwatermark-1tnesei/?bust=1666030589818#3-como-configurar-o-drm-dentro-da-plataforma'

export const DRM_LINK_EN_US =
  'https://help.pandavideo.com/en-us/article/what-is-drm-watermark-and-how-does-it-work-1tirjk3/#3-how-to-configure-drm-within-the-platform'

export const DRM_TICTO_LINK =
  'https://help.ticto.com.br/pt-br/article/como-inserir-marca-dagua-nos-videos-hospedados-no-panda-e-exibidos-no-mozart-ln0gcw/'

export const DRM_MEMBERKIT_LINK =
  'https://help.pandavideo.com/pt-br/article/como-integrar-o-drm-na-memberkit-6hlmzd/?bust=1678399048839'

export const DRM_HOTMART_LINK =
  'https://help.pandavideo.com/pt-br/article/como-integrar-o-drm-com-a-hotmart-1tzznzd/?bust=1666200945078'

export const DRM_EDUZZ_LINK =
  'https://help.pandavideo.com/pt-br/article/como-integrar-o-drm-com-a-eduzz-o34cjl/?bust=1666203565140'

export const PANDA_HELP_CONVERTING =
  'https://help.pandavideo.com/pt-br/article/video-demorando-demais-para-converter-1uvumg4'
export const VIDEO_SPEED_LINK =
  'https://help.pandavideo.com/pt-br/article/como-funciona-e-como-ativar-a-velocidade-de-reproducao-turbo-na-panda-v5z4id/'
export const US_VIDEO_SPEED_LINK =
  'https://help.pandavideo.com/en-us/article/how-does-the-playback-speed-turbo-feature-works-and-how-do-you-activate-it-at-panda-1c0o13p/'
export const PANDA_ASSIST_AI_BETA_LINK = 'https://forms.gle/pUFu8aKssiRyeSbD8'

export const PANDA_STATUS_PAGE = 'https://status.pandavideo.com/'

export const PANDA_STATUS_PAGE_BR = 'https://status.pandavideo.com/'

export const THUMB_URL = process.env.VUE_APP_THUMB_API

export const LIVE_CHAT = process.env.VUE_APP_LIVE_CHAT

export const CONFIG_URL = process.env.VUE_APP_CONFIG_API

export const BACKUP_UPLOADER_URL = process.env.VUE_APP_BACKUP_URL

export const BACKUP_DOWNLOADER_SERVER = process.env.VUE_APP_BACKUP_DOWNLOAD

export const ENV_CONFIG = process.env.VUE_APP_ENV

export const ENV_BRANDING_BLOCK = process.env.VUE_APP_BRANDING_BLOCK

export const PRICE_ID_BRONZE = process.env.VUE_APP_PRICE_ID_BRONZE
export const PRICE_ID_SILVER = process.env.VUE_APP_PRICE_ID_SILVER
export const PRICE_ID_GOLD = process.env.VUE_APP_PRICE_ID_GOLD
